var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();
//
// FIGURE.revealBody = function() {
// 	$.fn.isInViewport = function(bp = 0) {
// 		var elementTop = $(this).offset().top + bp;
// 		var elementBottom = elementTop + $(this).outerHeight();
// 		var viewportTop = $(window).scrollTop();
// 		var viewportBottom = viewportTop + $(window).height();
// 		return elementBottom > viewportTop && elementTop < viewportBottom;
// 	};
// 	if ($('.reveal-body p').length) {
// 		$(window).on('load resize scroll', function() {
// 			const revealPoint = $(window).height() / 4;
// 			const hidePoint = -$(window).height();
// 			$('.reveal-body p').each((i, p) => {
// 				if ($(p).isInViewport(revealPoint)) {
// 					$(p).addClass('show');
// 				}
// 			});
// 			$('.reveal-body p').each((i, p) => {
// 				if ($(p).isInViewport(hidePoint)) {
// 					$(p).removeClass('show');
// 				}
// 			});
// 		});
// 	}
// }();